import { z } from 'zod'

export const TIPOS_EQUIPAMENTO = [
  { value: 'split_hi_wall', label: 'Split Hi-Wall' },
  { value: 'split_cassete', label: 'Split Cassete' },
  { value: 'split_piso_teto', label: 'Split Piso-Teto' },
  { value: 'split_duto', label: 'Split Dutado' },
  { value: 'vrf_condensadora', label: 'VRF Condensadora' },
  { value: 'vrf_evaporadora', label: 'VRF Evaporadora' },
  { value: 'chiller', label: 'Chiller' },
  { value: 'self_contained', label: 'Self-Contained' },
  { value: 'uta', label: 'Unidade de Tratamento de Ar (UTA)' },
  { value: 'fancoil', label: 'Fan Coil' },
  { value: 'torre_resfriamento', label: 'Torre de Resfriamento' },
  { value: 'condensadora_ar', label: 'Condensadora a Ar' },
  { value: 'janela', label: 'Ar Condicionado de Janela' },
  { value: 'ptac', label: 'PTAC' },
  { value: 'outro', label: 'Outro' },
] as const

const TIPO_VALORES = TIPOS_EQUIPAMENTO.map((t) => t.value) as [string, ...string[]]

export const equipamentoSchema = z.object({
  empresa: z.string().min(1, 'Empresa é obrigatória'),
  tipo: z.enum(TIPO_VALORES, { errorMap: () => ({ message: 'Selecione o tipo' }) }),
  marca: z.string().min(1, 'Marca é obrigatória').max(100),
  modelo: z.string().min(1, 'Modelo é obrigatório').max(100),
  numero_serie: z.string().max(100).optional().or(z.literal('')),
  capacidade_btu: z
    .union([z.coerce.number().int().positive(), z.literal('')])
    .optional()
    .transform((v) => (v === '' || v === undefined ? undefined : v)),
  observacoes: z.string().max(2000).optional().or(z.literal('')),
})

export type EquipamentoFormData = z.infer<typeof equipamentoSchema>
